"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Skeleton_1 = __importDefault(require("../../../Skeleton/Skeleton"));
var PostStatisticsSkeleton = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
            react_1.default.createElement(Skeleton_1.default, null)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.data },
                react_1.default.createElement(Skeleton_1.default, null),
                react_1.default.createElement(Skeleton_1.default, null)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.sort },
                react_1.default.createElement(Skeleton_1.default, null))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.chart },
            react_1.default.createElement(Skeleton_1.default, { width: "100%", height: "100%" }))));
};
exports.default = PostStatisticsSkeleton;
